/* Bean Shipper — Find My Beans quiz (reveal-first fix, 13 Jul 2026; native sign-up 23 Sep 2026).
   Standalone copy of the quiz module from bean-shipper.js with two changes:
   (1) reveal-first: last question goes straight to the match (no email wall);
   (2) optional, non-blocking 'email me the brewing notes' capture on the result.
   23 Sep 2026: that capture is now a REAL Shopify customer form, protected by Shopify's own
   hCaptcha layer and submitted natively. The old path (copy the address into a hidden form and
   call f.submit() into a hidden iframe) never got a captcha token, so every sign-up since at
   least 14 Jul was rejected with 400 "Missing CAPTCHA token" while the quiz said "Sent".
   The answers are parked in sessionStorage before the page goes to /contact and the result is
   rebuilt from them when Shopify sends the visitor back with ?customer_posted=true.
   Mounts on #bs-fmb using a data-fmb2-ready guard. The bundle's built-in copy is
   neutralised by sections/bs-fmb-boot.liquid setting data-fmb-ready first. */
/* ===== Find My Beans — immersive personality quiz (mounts on #bs-fmb) ===== */
(function () {
  function initFMB() {
    var root = document.getElementById('bs-fmb');
    if (!root || root.getAttribute('data-fmb2-ready')) return;
    root.setAttribute('data-fmb2-ready', '1');

  var POOL = [], CFG = {};
  try { POOL = JSON.parse(document.getElementById('bs-fmb-products').textContent || '[]'); } catch (e) { POOL = []; }
  try { CFG = JSON.parse(document.getElementById('bs-fmb-config').textContent || '{}'); } catch (e) { CFG = {}; }
  var MARK = CFG.mark || '';

  function esc(s){ return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  function cap(s){ s = String(s || ''); return s.charAt(0).toUpperCase() + s.slice(1); }

  /* ---------- icons (stroke = currentColor) ---------- */
  function ic(paths){ return '<svg width="30" height="30" viewBox="0 0 22 22" aria-hidden="true" style="display:block">' + paths + '</svg>'; }
  function pp(d){ return '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>'; }
  var ICONS = {
    espresso: ic(pp('M5 9h11v4a5 5 0 0 1-5 5H10a5 5 0 0 1-5-5V9Z')+pp('M16 10h2.5a2.5 2.5 0 0 1 0 5H16')+pp('M8 3.5c-.6.7-.6 1.3 0 2M11 3c-.6.7-.6 1.3 0 2')),
    pourover: ic(pp('M4 7h14l-2.5 5.5a4 4 0 0 1-3.6 2.3H10.1a4 4 0 0 1-3.6-2.3L4 7Z')+pp('M9 18h4M11 15.8V18')+pp('M11 2.5v2.5')),
    dripbag: ic(pp('M6 5h10v3.5a5 5 0 0 1-5 5 5 5 0 0 1-5-5V5Z')+pp('M4.5 5h13')+pp('M8 13.8 7 19M14 13.8 15 19')),
    frenchpress: ic(pp('M7 8h8v10a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 7 18V8Z')+pp('M6.5 8h9M11 2.5V5m0 0H8.5m2.5 0h2.5')+pp('M11 5v3')),
    fruit: ic(pp('M11 8.5c4 0 5.5 3 5.5 5.5S14.5 20 11 20 5.5 16.5 5.5 14 7 8.5 11 8.5Z')+pp('M11 8.5C11 6 9.5 4 7 4M11 8.5c0-2 1.5-3.5 3.5-3.5')),
    cocoa: ic(pp('M5 6h12v3a6 6 0 0 1-12 0V6Z')+pp('M5 6 7 4h8l2 2M9 9.5l1.5 1.5L9 12.5M13 9.5 11.5 11 13 12.5')),
    nut: ic(pp('M11 4c3 0 5.5 3 5.5 7s-2.5 9-5.5 9-5.5-5-5.5-9S8 4 11 4Z')+pp('M11 4v16M7 9h8M7.5 14h7')),
    floral: ic(pp('M11 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z')+pp('M11 6.5C11 4 12.5 3 14 3.5s1.4 2.6-.5 3.8M11 6.5C11 4 9.5 3 8 3.5s-1.4 2.6.5 3.8')+pp('M11 11.5V20M11 14.5c-2-1-4-.5-5 0M11 14.5c2-1 4-.5 5 0')),
    compass: ic(pp('M11 19.5a8.5 8.5 0 1 0 0-17 8.5 8.5 0 0 0 0 17Z')+pp('M14.5 7.5 12.2 12.2 7.5 14.5 9.8 9.8 14.5 7.5Z')),
    anchor: ic(pp('M11 7.5V20M11 7.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z')+pp('M6 8h10M5 13c0 3.5 2.8 6 6 6s6-2.5 6-6M5 13l1.8 1M17 13l-1.8 1'))
  };

  /* ---------- quiz data ---------- */
  var QUESTIONS = [
    { id:'brew', cat:'Ritual', q:'How do you make your morning cup?', sub:"There's no wrong answer — only the one that feels like home.", layout:'cards', options:[
      { id:'espresso', label:'Espresso machine', desc:'Short, intense, no compromise', icon:'espresso', scores:{purist:2,comfort:1} },
      { id:'pourover', label:'Pour-over', desc:'Slow, deliberate, a little ceremony', icon:'pourover', scores:{explorer:2,romantic:1} },
      { id:'dripbag', label:'Drip bag', desc:'Good coffee, anywhere I land', icon:'dripbag', scores:{comfort:2,nightowl:1} },
      { id:'frenchpress', label:'French press', desc:'Full-bodied and unhurried', icon:'frenchpress', scores:{purist:1,comfort:1,explorer:1} }
    ]},
    { id:'flavor', cat:'Palate', q:'Which flavour makes you close your eyes?', sub:"Trust your gut — the cup that you'd reach for twice.", layout:'cards', options:[
      { id:'fruity', label:'Bright & fruity', desc:'Berries, citrus, a little sparkle', icon:'fruit', scores:{explorer:3,romantic:1} },
      { id:'chocolatey', label:'Rich & chocolatey', desc:'Cocoa, caramel, deep and round', icon:'cocoa', scores:{purist:3,comfort:1} },
      { id:'nutty', label:'Smooth & nutty', desc:'Almond, brown sugar, easy-going', icon:'nut', scores:{comfort:3,purist:1} },
      { id:'floral', label:'Delicate & floral', desc:'Jasmine, tea-like, light on its feet', icon:'floral', scores:{romantic:3,explorer:1} }
    ]},
    { id:'roast', cat:'Roast', q:'How dark do you like it?', sub:'From sun-kissed to midnight — pick your shade.', layout:'roast', options:[
      { id:'light', label:'Light', desc:'Tea-like, vivid, acidic', swatch:'#C9A06A', scores:{explorer:2,romantic:2} },
      { id:'medium', label:'Medium', desc:'Balanced, sweet, familiar', swatch:'#8A5333', scores:{comfort:2,romantic:1} },
      { id:'dark', label:'Dark', desc:'Bold, smoky, full force', swatch:'#3A2218', scores:{purist:3,nightowl:1} }
    ]},
    { id:'spirit', cat:'Spirit', q:"At the counter, you're the kind who…", sub:'Be honest — both are a perfectly good way to live.', layout:'cards', options:[
      { id:'surprise', label:'“Surprise me”', desc:'Always chasing the next discovery', icon:'compass', scores:{explorer:3,romantic:1} },
      { id:'reliable', label:'“The usual”', desc:'Found my order, never looked back', icon:'anchor', scores:{comfort:2,purist:2} }
    ]}
  ];
  var N = QUESTIONS.length;

  var PROFILES = {
    explorer: { name:'The Explorer', tagline:'You drink to discover.',
      blurb:"You treat every cup like a postcard from somewhere new — the brighter and stranger, the better. A washed Ethiopian with blueberry and jasmine isn't a novelty to you; it's the point.",
      traits:['Bright','Adventurous','Light roast'], runnerUp:'romantic',
      target:{ roast:'light-roast', flavors:['fruity','floral'] } },
    purist: { name:'The Purist', tagline:'You take it seriously, and straight.',
      blurb:"No frills, no fuss — just a deep, chocolatey shot pulled the way it should be. You know what you like, and you've earned the right to be particular about it.",
      traits:['Bold','Reliable','Dark roast'], runnerUp:'comfort',
      target:{ roast:'dark-roast', flavors:['chocolate','caramel'] } },
    romantic: { name:'The Romantic', tagline:'You drink for the moment, not the rush.',
      blurb:'Coffee is a slow ceremony for you — floral, tea-like, poured by hand while the kettle ticks. You’d rather savour one beautiful cup than gulp three good ones.',
      traits:['Floral','Considered','Light–medium'], runnerUp:'explorer',
      target:{ roast:'light-roast', flavors:['floral','fruity'] } },
    comfort: { name:'The Comfort Seeker', tagline:'You drink for the warm, familiar middle.',
      blurb:"Smooth, nutty, dependable — the cup that feels like a soft landing. You don't need fireworks; you need a brew that's good every single morning without asking much of you.",
      traits:['Smooth','Easy-going','Medium roast'], runnerUp:'purist',
      target:{ roast:'medium-roast', flavors:['nutty','caramel'] } },
    nightowl: { name:'The Night Owl', tagline:'You love the cup, not the jitters.',
      blurb:'Coffee, for you, is comfort after hours — a cocoa-rich, low-caffeine companion for late reading and slow evenings. Proof that good coffee was never really about the buzz.',
      traits:['Mellow','Late-night','Decaf-friendly'], runnerUp:'comfort',
      target:{ roast:'medium-roast', flavors:['chocolate'], decaf:true } }
  };
  var ORDER = ['explorer','purist','romantic','comfort','nightowl'];

  function scoreQuiz(answers){
    var totals = { explorer:0, purist:0, romantic:0, comfort:0, nightowl:0 };
    QUESTIONS.forEach(function(question){
      var chosenId = answers[question.id];
      if (!chosenId) return;
      var opt = null;
      question.options.forEach(function(o){ if (o.id === chosenId) opt = o; });
      if (!opt || !opt.scores) return;
      Object.keys(opt.scores).forEach(function(k){ totals[k] = (totals[k] || 0) + opt.scores[k]; });
    });
    var best = ORDER[0];
    ORDER.forEach(function(k){ if (totals[k] > totals[best]) best = k; });
    return best;
  }

  /* match a real product to a personality */
  function productScore(p, target){
    var s = 0;
    if (p.match_roast === target.roast) s += 3;
    var fl = p.match_flavor || [];
    (target.flavors || []).forEach(function(f){ if (fl.indexOf(f) !== -1) s += 2; });
    if (target.decaf && /decaf/i.test((p.id || '') + ' ' + (p.name || ''))) s += 3;
    return s;
  }
  /* 23 Sep 2026: a drip box is a box of sachets, not a bag of beans, and this quiz sells beans. The
     shipper-classic pool now carries three drip-box-* products; "Drip Box Rwanda Inzovu Peaberry" is
     tagged Medium Light, the section reads 'light' out of it, and it was the only light roast in the
     pool - so The Explorer and The Romantic both landed on a 6-sachet box with 4 units in stock.
     Matches name AND handle, so a bean whose VARIANT is a Drip grind is never caught. */
  function isDrip(p){ return /drip/i.test((p.name || '') + ' ' + (p.id || '')); }

  function bestProduct(profileId, excludeHandle){
    if (!POOL.length) return null;
    var target = PROFILES[profileId].target;
    var best = null, bestScore = -1;
    for (var i = 0; i < POOL.length; i++){
      var p = POOL[i];
      if (excludeHandle && p.id === excludeHandle) continue;
      if (p.bundle) continue; // bundles never match — the quiz recommends single bags
      if (p.available === false) continue;
      if (isDrip(p)) continue;
      var sc = productScore(p, target);
      if (sc > bestScore){ bestScore = sc; best = p; }
    }
    if (!best){ // fallback: first available not excluded
      for (var j = 0; j < POOL.length; j++){ if (POOL[j].id !== excludeHandle && !POOL[j].bundle && POOL[j].available !== false && !isDrip(POOL[j])){ best = POOL[j]; break; } }
    }
    return best || POOL[0];
  }

  function roastLabel(r){ return r === 'light-roast' ? 'Light Roast' : r === 'dark-roast' ? 'Dark Roast' : 'Medium Roast'; }
  function originLabel(p){ var nm = p.name || ''; var m = nm.match(/Ethiopia|Kenya|Rwanda|Burundi|Tanzania|Uganda|Colombia|Brazil|Guatemala|Peru|Costa Rica|El Salvador|Honduras|Panama|Bolivia|Mexico|Indonesia|Sumatra|Java|Flores|Malaysia|Papua New Guinea|Taiwan|Vietnam|India|Yemen/i); if (m) return m[0] + ' · Single Origin'; if (/blend|box|trio|pack|bundle|subscription|signature/i.test(nm)) return 'Bean Shipper Blend'; return 'Bean Shipper · Single Origin'; }
  function noteChips(p){
    var notes = (p.notes || '').split(/[,·•]/).map(function(n){ return n.trim(); }).filter(Boolean);
    if (!notes.length) notes = (p.match_flavor || []).map(cap);
    return notes.slice(0, 3);
  }
  function fmtFormat(p){ var f = (heroV && heroV.title) || p.format || ''; if (!f || /default title/i.test(f)) return 'Whole bean'; return f; }

  /* pick the variant whose grind matches the brew answer (fallback: whole bean, then first available) */
  var GRIND_BY_BREW = { espresso:'espresso', frenchpress:'french press', dripbag:'drip', pourover:'whole bean' };
  function pickVariant(p){
    var vs = (p && p.variants) || [];
    if (!vs.length) return p ? { id: p.variant_id, title: p.format } : null;
    var want = GRIND_BY_BREW[answers.brew] || 'whole bean';
    var i, t;
    for (i = 0; i < vs.length; i++){ t = String(vs[i].title || '').toLowerCase(); if (t.indexOf(want) !== -1 && vs[i].available !== false) return vs[i]; }
    for (i = 0; i < vs.length; i++){ t = String(vs[i].title || '').toLowerCase(); if (t.indexOf('whole bean') !== -1 && vs[i].available !== false) return vs[i]; }
    for (i = 0; i < vs.length; i++){ if (vs[i].available !== false) return vs[i]; }
    return vs[0];
  }

  /* ---------- state ---------- */
  var step = 'intro', answers = {}, chosen = null, result = null, heroP = null, heroV = null, runnerP = null, runnerProfileId = null, added = false;
  var advTimer = null, brewTimer = null, toastTimer = null;
  var shell = null, els = {};
  var noteSent = false, restoreError = '', restoredEmail = '';

  /* ---------- native sign-up (hCaptcha-safe) ----------
     Shopify's captcha-bootstrap guards every /contact customer form. Shopify.captcha.protect(form)
     binds hCaptcha to THIS form (it swaps form.submit for a captcha-first wrapper and adds its own
     submit handler); the handler below only validates, parks the quiz state and gets out of the way.
     Never post these forms by script: an unbound form gets no token and Shopify rejects it. */
  var PENDING_KEY = 'bsfmb:pending', REVEALED_KEY = 'bsfmb:revealed';
  var CAPTURE_TAGS = 'newsletter, find-my-beans';
  function ssGet(k){ try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function ssSet(k, v){ try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function ssDel(k){ try { sessionStorage.removeItem(k); } catch (e) {} }
  function isFresh(o){ return !!(o && o.answers && o.path === location.pathname && (Date.now() - (o.ts || 0)) < 45 * 60 * 1000); }
  function savePending(mode, email, submitted){
    ssSet(PENDING_KEY, { mode: mode, answers: answers, email: email, submitted: !!submitted, path: location.pathname, ts: Date.now() });
  }
  function contactAction(){
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'contact#bs-fmb';
  }
  function signupFormHTML(cls, inputCls, btnCls, btnLabel){
    return '<form class="' + cls + '" method="post" action="' + esc(contactAction()) + '" accept-charset="UTF-8" data-act="signup-form" novalidate>' +
      '<input type="hidden" name="form_type" value="customer">' +
      '<input type="hidden" name="utf8" value="\u2713">' +
      '<input type="hidden" name="contact[tags]" value="' + esc(CAPTURE_TAGS) + '">' +
      '<input class="' + inputCls + '" type="email" name="contact[email]" inputmode="email" placeholder="you@email.com" aria-label="Email address" autocomplete="email" required value="' + esc(restoredEmail) + '">' +
      '<button class="' + btnCls + '" type="submit">' + esc(btnLabel) + '</button>' +
    '</form>';
  }
  function captchaOn(){ return !!(window.Shopify && Shopify.captcha && typeof Shopify.captcha.protect === 'function'); }
  function isBound(form){ return !!(form.getAttribute('data-hcaptcha-bound') || form.getAttribute('data-recaptcha-bound')); }
  function protectForm(form){ try { if (captchaOn() && !form.getAttribute('data-cptcha')) Shopify.captcha.protect(form); } catch (e) {} }
  function bindSignup(form, mode, onMsg){
    var input = form.querySelector('input[name="contact[email]"]');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    function resetBtn(){ if (btn){ btn.disabled = false; btn.textContent = label; } }
    protectForm(form);
    if (input) input.addEventListener('input', function(){
      if (onMsg) onMsg('');
      var v = (input.value || '').trim();
      if (v) savePending(mode, v, false);
    });
    /* capture phase on the form itself: runs before the hCaptcha handler and Shopify's own
       document-level handler, so a bad address never reaches either of them. */
    form.addEventListener('submit', function(e){
      var v = ((input && input.value) || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){
        e.preventDefault(); e.stopImmediatePropagation();
        if (onMsg) onMsg('Please enter a valid email so we can send your brewing notes.');
        return;
      }
      if (onMsg) onMsg('');
      savePending(mode, v, true);
      if (!captchaOn() || isBound(form)){
        if (btn){ btn.disabled = true; btn.textContent = 'Sending\u2026'; }
        setTimeout(resetBtn, 9000); /* the visitor may close an hCaptcha challenge */
        return; /* hCaptcha and Shopify take it from here: token, then a native POST */
      }
      /* protected but not bound yet (provider script still loading): hold, then re-submit */
      e.preventDefault(); e.stopImmediatePropagation();
      if (form.getAttribute('data-bs-waiting')) return;
      form.setAttribute('data-bs-waiting', '1');
      protectForm(form);
      if (btn){ btn.disabled = true; btn.textContent = 'One moment\u2026'; }
      var tries = 0;
      var t = setInterval(function(){
        tries++;
        if (isBound(form)){
          clearInterval(t); form.removeAttribute('data-bs-waiting'); resetBtn();
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        } else if (tries >= 60){
          clearInterval(t); form.removeAttribute('data-bs-waiting'); resetBtn();
          if (onMsg) onMsg('Our sign-up check did not load. Please try again, or pause an ad blocker for this page.');
        }
      }, 150);
    }, true);
  }
  function cleanUrl(){
    try {
      var u = new URL(location.href);
      ['customer_posted', 'contact_posted', 'form_key', 'form_type'].forEach(function(k){ u.searchParams.delete(k); });
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }
  /* Coming back from Shopify. ?customer_posted=true is the ONLY confirmed sign-up. Anything else
     with a parked state (challenge round-trip, back button, error page, a refresh) resumes where
     the visitor was, email pre-filled. */
  function restoreFromPending(){
    var qs = null;
    try { qs = new URLSearchParams(location.search); } catch (e) { qs = null; }
    var posted = !!qs && qs.get('customer_posted') === 'true';
    var p = ssGet(PENDING_KEY), rv = ssGet(REVEALED_KEY);
    var src = isFresh(p) ? p : (isFresh(rv) ? rv : null);
    if (!src) return false;
    answers = src.answers || {};
    restoredEmail = src.email || '';
    result = scoreQuiz(answers);
    heroP = bestProduct(result, null);
    if (!heroP){ ssDel(PENDING_KEY); ssDel(REVEALED_KEY); answers = {}; result = null; restoredEmail = ''; return false; }
    heroV = pickVariant(heroP);
    runnerProfileId = PROFILES[result].runnerUp;
    runnerP = bestProduct(runnerProfileId, heroP.id);
    if (src === p && posted){
      ssDel(PENDING_KEY);
      ssSet(REVEALED_KEY, { answers: answers, email: restoredEmail, path: location.pathname, ts: Date.now() });
      noteSent = true;
      onSignupConfirmed(src);
      cleanUrl();
      step = 'result';
      return true;
    }
    if (src === rv){ noteSent = true; step = 'result'; return true; }
    if (p.submitted) restoreError = 'We couldn\u2019t confirm that email yet. Please check it and try again.';
    step = 'result'; /* GATED-BUILD-RETURN-STEP */
    return true;
  }
  function onSignupConfirmed(p){ /* GATED-BUILD-CONFIRMED */ }
  function sentHTML(){
    return '<div class="fmb-note" style="margin-top:20px;max-width:440px"><span class="result__eyebrow" style="display:block;color:var(--bs-red)">Sent \u2014 brewing notes are on the way \u2713</span></div>';
  }
  function noteFormHTML(){
    return '<div class="fmb-note" style="margin-top:20px;max-width:440px">' +
      '<span class="result__eyebrow" style="display:block;margin-bottom:10px">Want the brewing notes? We\u2019ll email them.</span>' +
      signupFormHTML('fmb-note__form', 'fmb-note__input', 'btn btn--secondary', 'Email me') +
      '<div class="fmb-note__msg" role="alert" style="min-height:16px;margin-top:8px;font-size:12px;letter-spacing:.02em;color:#B61F2E">' + esc(restoreError) + '</div>' +
    '</div>';
  }

  function buildShell(){
    root.innerHTML =
      '<div class="stage">' +
        '<div class="progress"><div class="progress__fill"></div></div>' +
        '<div class="topbar"></div>' +
        '<div class="screen"><div class="screen__scroll"></div></div>' +
      '</div>' +
      '<div class="toast"><span class="dot"></span><span class="toast__msg"></span></div>';
    els.stage = root.querySelector('.stage');
    els.fill = root.querySelector('.progress__fill');
    els.topbar = root.querySelector('.topbar');
    els.scroll = root.querySelector('.screen__scroll');
    els.toast = root.querySelector('.toast');
    els.toastMsg = root.querySelector('.toast__msg');
  }

  function showToast(msg){
    els.toastMsg.textContent = msg;
    els.toast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ els.toast.classList.remove('show'); }, 2400);
  }

  function brandmark(){
    return '<a class="brandmark" href="' + esc(CFG.homeUrl || '/') + '" aria-label="Bean Shipper home">' +
      (MARK ? '<img src="' + esc(MARK) + '" alt="Bean Shipper">' : '') +
      '<span class="brandmark__txt">Bean Shipper</span></a>';
  }

  function renderTopbar(){
    var isQuestion = typeof step === 'number';
    var showBack = isQuestion || step === 'gate';
    var stepNum = isQuestion ? step + 1 : (step === 'gate' ? N : null);
    var total = (step === 'intro' || step === 'brewing' || step === 'result') ? null : N;
    var html = '<span></span><div class="topbar__meta">';
    if (showBack) html += '<button class="topbtn" data-act="back">← Back</button>';
    if (total != null) html += '<div class="step-count"><b>' + String(stepNum).padStart(2,'0') + '</b> / ' + String(total).padStart(2,'0') + '</div>';
    html += '</div>';
    els.topbar.innerHTML = html;
  }

  function progressPct(){
    if (typeof step === 'number') return ((step + 1) / (N + 2)) * 100;
    if (step === 'gate') return ((N + 1) / (N + 2)) * 100;
    if (step === 'brewing' || step === 'result') return 100;
    return 0;
  }

  /* ---------- screen markup ---------- */
  function introHTML(){
    return '<div class="intro">' +
      '<div class="intro__left stagger">' +
        '<div class="intro__eyebrow">' + esc(CFG.eyebrow) + '</div>' +
        '<h1 class="intro__title">' + (CFG.headline || 'Find My<br><em>beans.</em>') + '</h1>' +
        '<p class="intro__lede">' + esc(CFG.lede) + '</p>' +
        '<div class="intro__cta">' +
          '<button class="btn btn--primary btn--xl" data-act="start">Start the quiz</button>' +
          '<span class="intro__meta">' + N + ' questions · 60 seconds</span>' +
        '</div>' +
      '</div>' +
      '<div class="intro__right">' +
        (CFG.photo ? '<img class="photo" src="' + esc(CFG.photo) + '" alt="Bean Shipper coffee">' : '') +
        (MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="">' : '') +
        '<div class="intro__rquote">Every cup is a postcard. Let’s find yours.</div>' +
      '</div>' +
    '</div>';
  }

  function questionHTML(q, index){
    var isRoast = q.layout === 'roast';
    var cols = q.options.length === 2 ? 'cols-2' : (isRoast ? 'roast' : 'cols-4');
    var wm = MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="" style="width:38%;right:-9%;bottom:-12%">' : '';
    var head = '<div class="qhead rise">' +
      '<div class="eyebrow-q">Question ' + String(index + 1).padStart(2,'0') + ' · ' + esc(q.cat) + '</div>' +
      '<h2 class="qtitle">' + esc(q.q) + '</h2>' +
      (q.sub ? '<p class="qsub">' + esc(q.sub) + '</p>' : '') +
    '</div>';
    var opts = q.options.map(function(opt, i){
      var letter = String.fromCharCode(65 + i);
      if (isRoast){
        var lit = i + 1, meter = '';
        for (var k = 0; k < q.options.length; k++) meter += '<i class="' + (k < lit ? 'on' : '') + '"></i>';
        return '<button class="opt opt--roast" data-opt="' + esc(opt.id) + '">' +
          '<span class="opt__no">' + letter + '</span>' +
          '<span class="opt__swatch" style="background:' + esc(opt.swatch) + '"></span>' +
          '<span class="opt__label">' + esc(opt.label) + '</span>' +
          '<span class="opt__desc">' + esc(opt.desc) + '</span>' +
          '<span class="roast-meter">' + meter + '</span>' +
        '</button>';
      }
      return '<button class="opt" data-opt="' + esc(opt.id) + '">' +
        '<span class="opt__no">' + letter + '</span>' +
        '<span class="opt__icon">' + (ICONS[opt.icon] || '') + '</span>' +
        '<span class="opt__label">' + esc(opt.label) + '</span>' +
        '<span class="opt__desc">' + esc(opt.desc) + '</span>' +
      '</button>';
    }).join('');
    return '<div class="qwrap">' + wm + head + '<div class="opts ' + cols + ' stagger">' + opts + '</div></div>';
  }

  function gateHTML(){
    var wm = MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="" style="width:44%;left:-12%;top:-14%;filter:brightness(0) invert(1);opacity:.12">' : '';
    return '<div class="gate">' + wm +
      '<div class="stagger" style="display:contents">' +
        '<div class="gate__bean"><div class="steam"><span></span><span></span><span></span></div>' + (MARK ? '<img src="' + esc(MARK) + '" alt="">' : '') + '</div>' +
        '<h2 class="gate__title">Your blend is <em>ready.</em></h2>' +
        '<p class="gate__sub">Tell us where to send it. We’ll reveal your match on the next screen — and email the brewing notes so you nail the first cup.</p>' +
        '<form class="gate__form" data-act="gate-form" novalidate>' +
          '<input class="gate__input" type="email" inputmode="email" placeholder="you@email.com" aria-label="Email address" autocomplete="email">' +
          '<button class="gate__btn" type="submit">Reveal my match</button>' +
        '</form>' +
        '<div class="gate__err"></div>' +
        '<div class="gate__fine">Fresh roasts &amp; tips. No spam. Unsubscribe anytime.</div>' +
        '<button class="gate__back" data-act="back">← Back to questions</button>' +
      '</div>' +
    '</div>';
  }

  function brewingHTML(){
    return '<div class="brewing">' +
      '<div class="brewing__bean">' + (MARK ? '<img class="ghost" src="' + esc(MARK) + '" alt=""><img class="fill" src="' + esc(MARK) + '" alt="">' : '') + '</div>' +
      '<div class="brewing__label rise">Brewing your match…</div>' +
      '<div class="brewing__dots"><i></i><i></i><i></i></div>' +
    '</div>';
  }

  function resultHTML(){
    var prof = PROFILES[result];
    var p = heroP;
    var wm = MARK ? '<img class="bean-wm" src="' + esc(MARK) + '" alt="" style="width:30%;left:-8%;bottom:-10%">' : '';
    var traits = prof.traits.map(function(t){ return '<span class="trait">' + esc(t) + '</span>'; }).join('');
    var chips = noteChips(p).map(function(n){ return '<span class="notechip">' + esc(n) + '</span>'; }).join('');
    var runnerHTML = '';
    if (runnerP){
      runnerHTML = '<a class="runnerup" href="' + esc(runnerP.url) + '">' +
        '<div class="runnerup__thumb">' + (runnerP.image ? '<img src="' + esc(runnerP.image) + '" alt="' + esc(runnerP.name) + '">' : '') + '</div>' +
        '<div class="runnerup__txt"><span class="runnerup__label">Also worth a try</span>' +
        '<span class="runnerup__name">' + esc(runnerP.name) + ' · <b>' + esc(PROFILES[runnerProfileId].name) + '</b></span></div>' +
      '</a>';
    }
    return '<div class="result">' + wm +
      '<div class="result__grid">' +
        '<div class="stagger">' +
          '<div class="result__eyebrow">Your coffee personality</div>' +
          '<h1 class="result__name">' + esc(prof.name) + '</h1>' +
          '<p class="result__tagline">' + esc(prof.tagline) + '</p>' +
          '<div class="result__traits">' + traits + '</div>' +
          '<p class="result__blurb">' + esc(prof.blurb) + '</p>' +
          '<div class="result__actions">' +
            '<button class="btn btn--secondary" data-act="retake">Retake quiz</button>' +
            '<button class="btn btn--ghost" data-act="share">Share result</button>' +
          '</div>' +
          (noteSent ? sentHTML() : noteFormHTML()) + runnerHTML +
        '</div>' +
        '<div class="rise" style="animation-delay:calc(2 * var(--anim-stagger))">' +
          '<div class="prodcard">' +
            '<div class="prodcard__media"><span class="prodcard__tag">Your match</span>' +
              '<a href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.name) + '">' : '') + '</a></div>' +
            '<div class="prodcard__body">' +
              '<div class="prodcard__origin">' + esc(p.origin_label || originLabel(p)) + '</div>' +
              '<h3 class="prodcard__name"><a href="' + esc(p.url) + '">' + esc(p.name) + '</a></h3>' +
              '<div class="notechips">' + chips + '</div>' +
              '<div class="prodcard__spec">' +
                '<div><div class="k">Roast</div><div class="v">' + esc(roastLabel(p.match_roast)) + '</div></div>' +
                '<div><div class="k">Format</div><div class="v">' + esc(fmtFormat(p)) + '</div></div>' +
              '</div>' +
              '<div class="prodcard__foot">' +
                '<div class="prodcard__price">' + esc(p.price_formatted) + '<small>Free shipping from RM80</small></div>' +
                '<button class="btn btn--primary" data-act="add"' + (added ? ' disabled' : '') + '>' + (added ? 'Added ✓' : 'Add to cart') + '</button>' +
              '</div>' +
              '<a class="prodcard__more" href="' + esc(p.url) + '">See full details, grinds &amp; reviews →</a>' +
              '<a class="prodcard__sub" href="/pages/coffee-subscriptions">Prefer it on repeat? Subscriptions ship free within Malaysia, every cycle →</a>' +
              '<a class="prodcard__viewbag' + (added ? ' show' : '') + '" href="' + esc(CFG.cartUrl || '/cart') + '">View bag →</a>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  /* ---------- render ---------- */
  function render(){
    var dark = step === 'gate' || step === 'brewing';
    els.stage.className = 'stage' + (dark ? ' is-dark' : '');
    els.fill.style.width = progressPct() + '%';
    renderTopbar();
    var html;
    if (step === 'intro') html = introHTML();
    else if (typeof step === 'number') html = questionHTML(QUESTIONS[step], step);
    else if (step === 'gate') html = gateHTML();
    else if (step === 'brewing') html = brewingHTML();
    else html = resultHTML();
    els.scroll.innerHTML = html;
    els.scroll.scrollTop = 0;
    bindScreen();
  }

  function bindScreen(){
    var startBtn = els.scroll.querySelector('[data-act="start"]');
    if (startBtn) startBtn.addEventListener('click', function(){ step = 0; render(); });

    var opts = els.scroll.querySelectorAll('.opt');
    if (opts.length){
      opts.forEach(function(btn){
        btn.addEventListener('click', function(){ choose(btn.getAttribute('data-opt'), btn); });
      });
    }

    var form = els.scroll.querySelector('[data-act="gate-form"]');
    if (form){
      var input = form.querySelector('.gate__input');
      setTimeout(function(){ if (input) input.focus(); }, 500);
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var v = (input.value || '').trim();
        var ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
        var err = els.scroll.querySelector('.gate__err');
        if (!ok){ input.classList.add('is-error'); if (err) err.textContent = 'Please enter a valid email so we can send your match.'; return; }
        input.classList.remove('is-error'); if (err) err.textContent = '';
        captureEmail(v);
        toBrewing();
      });
      input.addEventListener('input', function(){ input.classList.remove('is-error'); var err = els.scroll.querySelector('.gate__err'); if (err) err.textContent = ''; });
    }

    var retake = els.scroll.querySelector('[data-act="retake"]');
    if (retake) retake.addEventListener('click', doRetake);
    var shareB = els.scroll.querySelector('[data-act="share"]');
    if (shareB) shareB.addEventListener('click', doShare);
    var addB = els.scroll.querySelector('[data-act="add"]');
    if (addB) addB.addEventListener('click', addToCart);
    var noteForm = els.scroll.querySelector('.fmb-note__form');
    if (noteForm){
      var noteMsg = els.scroll.querySelector('.fmb-note__msg');
      bindSignup(noteForm, 'note', function(msg){ if (noteMsg) noteMsg.textContent = msg || ''; });
    }

    var backB = els.topbar.querySelector('[data-act="back"]');
    if (backB) backB.addEventListener('click', goBack);
    var backB2 = els.scroll.querySelector('[data-act="back"]');
    if (backB2) backB2.addEventListener('click', goBack);
  }

  function choose(optId, btn){
    if (chosen) return;
    var q = QUESTIONS[step];
    chosen = optId;
    answers[q.id] = optId;
    if (btn) btn.classList.add('is-chosen');
    clearTimeout(advTimer);
    advTimer = setTimeout(function(){
      chosen = null;
      if (step < N - 1) { step = step + 1; render(); } else { toBrewing(); }
    }, 360);
  }

  function goBack(){
    clearTimeout(advTimer); chosen = null;
    if (step === 'gate') step = N - 1;
    else if (typeof step === 'number' && step > 0) step = step - 1;
    else if (step === 0) step = 'intro';
    render();
  }

  function toBrewing(){
    result = scoreQuiz(answers);
    heroP = bestProduct(result, null);
    heroV = heroP ? pickVariant(heroP) : null;
    runnerProfileId = PROFILES[result].runnerUp;
    runnerP = bestProduct(runnerProfileId, heroP ? heroP.id : null);
    step = 'brewing'; render();
    clearTimeout(brewTimer);
    brewTimer = setTimeout(function(){ step = 'result'; render(); }, 2150);
  }

  function doRetake(){
    clearTimeout(advTimer); clearTimeout(brewTimer);
    answers = {}; chosen = null; result = null; heroP = null; heroV = null; runnerP = null; added = false;
    noteSent = false; restoreError = ''; restoredEmail = ''; ssDel(PENDING_KEY); ssDel(REVEALED_KEY);
    step = 'intro'; render();
  }

  function doShare(){
    var txt = 'I’m “' + (result ? PROFILES[result].name : 'a coffee lover') + '” — find your Bean Shipper match.';
    if (navigator.share){ navigator.share({ title: 'Bean Shipper Taste Profile', text: txt, url: location.href }).catch(function(){}); }
    else if (navigator.clipboard){ navigator.clipboard.writeText(location.href).then(function(){ showToast('Result link copied'); }).catch(function(){ showToast('Result link copied'); }); }
    else showToast('Result link copied');
  }

  /* Retired 23 Sep 2026. It copied the address into the hidden #bs-fmb-capture form and called
     f.submit() into the hidden iframe: never bound, never tokenised, always rejected by Shopify
     (400 "Missing CAPTCHA token"). Only the unreachable pre-14-Jul 'gate' step still calls it. */
  function captureEmail(email){ savePending('gate', email, false); }

  function addToCart(){
    if (added || !heroP) return;
    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: (heroV && heroV.id) || heroP.variant_id, quantity: 1 })
    }).then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); }).then(function(){
      added = true;
      var btn = els.scroll.querySelector('[data-act="add"]');
      if (btn){ btn.textContent = 'Added ✓'; btn.setAttribute('disabled', 'disabled'); }
      var vb = els.scroll.querySelector('.prodcard__viewbag');
      if (vb) vb.classList.add('show');
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      showToast(heroP.name + ' added to cart');
    }).catch(function(){ showToast('Could not add — try again'); });
  }

  /* ---------- mount ---------- */
  document.documentElement.classList.add('bs-fmb-lock');
  if (!document.getElementById('bs-fmb-signup-css')){
    var st = document.createElement('style');
    st.id = 'bs-fmb-signup-css';
    st.textContent =
      '#bs-fmb .fmb-note__form{display:flex;gap:8px;flex-wrap:wrap}' +
      '#bs-fmb .fmb-note__input{flex:1 1 220px;min-width:0;border:1px solid var(--bs-rule,rgba(26,26,26,.18));background:var(--bs-white,#fff);color:var(--bs-ink,#1A1A1A);padding:13px 15px;font-family:var(--font-sans,inherit);font-size:16px;border-radius:0}' +
      '#bs-fmb .fmb-note__input:focus{outline:none;border-color:var(--bs-red,#B61F2E)}' +
      '#bs-fmb .fmb-note__form .h-captcha,#bs-fmb .fmb-gate__form .h-captcha{flex:0 0 0;width:0;height:0;overflow:hidden}';
    document.head.appendChild(st);
  }
  buildShell();
  restoreFromPending();
  render();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFMB);
  else initFMB();
  document.addEventListener('shopify:section:load', initFMB);
})();
